import React from 'react';
import { EVENT_ATTRIBUTES_BY_EVENT_TYPE, FORM_SUBMITTED } from 'src/constants/constants';
import { Step } from 'src/types';

import FormBuilder from './FormBuilder';

interface Props {
  step: Step,
}

const TriggerBuilder = ({ step }: Props) => {
  // @ts-ignore
  const Component = EVENT_ATTRIBUTES_BY_EVENT_TYPE[step.trigger.triggerType].stepBuilderComponent;

  return <Component step={step} />;
};

export default TriggerBuilder;
